"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Grid = _interopRequireDefault(require("@commerce-ui/core2/Grid"));
var _Container = _interopRequireDefault(require("@commerce-ui/core2/Container"));
var __jsx = _react["default"].createElement;
var Grid2Cards = function Grid2Cards(props) {
  var children = props.children;
  return __jsx(_Container["default"], null, __jsx(_Grid["default"], {
    cols: [1, 1, 2, 2, 2]
  }, children));
};
var _default = Grid2Cards;
exports["default"] = _default;